<form [formGroup]="form" class="social-security-document-form">
  <app-document-form
    formControlName="socialSecurityCertificate"
    tag="socialSecurityCertificate"
    (uploaded)="onDocumentUploaded($event)"
    [required]="true"
  ></app-document-form>
  <mat-form-field class="w-100">
    <mat-label>Numéro de sécurité sociale</mat-label>
    <input matInput formControlName="socialSecurityNumber" appSsnFormatter [required]="true" />
    @if (form.controls.socialSecurityNumber.hasError('invalidLength')) {
      <mat-error>Le numéro de sécurité sociale doit comporter 15 caractères.</mat-error>
    }
    @if (form.controls.socialSecurityNumber.hasError('invalidControlKey')) {
      <mat-error>Le numéro ne vérifie pas la clé de contrôle.</mat-error>
    }
  </mat-form-field>
</form>
